import {InjectionToken, Provider} from '@angular/core';

export type StepLabels = {
    titleKey: string;
    hintKey: string;
};

export const STEP_LABELS = new InjectionToken<StepLabels>('STEP_LABELS');

export function stepLabels(titleKey: string, hintKey: string): Provider {
    return {provide: STEP_LABELS, useValue: {titleKey, hintKey}};
}
